module.exports = {
	events: {
		showInfo: {
			type: 'mouseenter',
			selector: '.templates_newsletter_mailings_edit_stats_charts_singleSemiDoughnut',
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target).closest('.templates_newsletter_mailings_edit_stats_charts_singleSemiDoughnut');
				if($target.length > 0){
					var chart = getComponent($target);
					var info = ((chart || {}).model || {}).info || '';
					self.triggerFind('updateInfo', { info });
				}
			}
		},

		hideInfo: {
			type: 'mouseleave',
			selector: '.templates_newsletter_mailings_edit_stats_charts_singleSemiDoughnut',
			action: function(event){
				event.data.component.triggerFind('updateInfo');
			}
		}
	},

	methods: {
		getResourceFilters: function(storage, resourceFilters, actionKey){
			if(actionKey === 'refreshResources'){
				var mailingID = (this.resourceData || {}).mailingID || 0;
				if(mailingID){
					resourceFilters = resourceFilters || {};
					resourceFilters.mailingID = mailingID;
				}
			}
			return resourceFilters;
		},

		sanitizeResources: function(storage){
			if(!storage.isServer){
				this.updateCharts();
			}
		},

		updateCharts: function(){
			this.triggerFind('update', {
				mailingResourceData: (this.resourceData || {}).data || {}
			}, 'templates_newsletter_mailings_simpleStatCharts');
			this.triggerFind('update', {
				mailingResourceData: (this.resourceData || {}).data || {}
			}, 'templates_newsletter_mailings_edit_stats_charts_singleSemiDoughnut');
		}
	},

	hooks: {
		postTabFocus: function($element, options){
			this.updateCharts();
		}
	}
}